import { Component } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

export interface IMenuHeaderParams {
  /** Options for the dropdown menu */
  selectOptions: string[];
  /** Function called when option is selected.  Return value is whether checkbox should be checked. */
  onSelect: (selectedOption: string) => boolean;
}

@Component({
  selector: 'ag-checkbox-menu-header',

  template: `<div class="flex flex-row">
    <input
      style="min-height: 16px; min-width: 16px"
      type="checkbox"
      [(ngModel)]="checked"
      (click)="selectType.open()" />
    <div class="mat-select-arrow-wrapper" style="margin-top: -3px">
      <mat-select #selectType [(ngModel)]="selectedOption" [panelWidth]="null" (selectionChange)="onSelectionChange($event)">
        <mat-option *ngFor="let t of selectOptions" [value]="t">
          {{ t }}
        </mat-option>
      </mat-select>
    </div>
  </div>`,
  styles: [],
})
export class CheckboxMenuHeaderComponent implements IHeaderAngularComp {
  public params!: IHeaderParams & IMenuHeaderParams;
  checked: boolean;
  selectedOption: string;
  selectOptions: string[];

  agInit(params: IHeaderParams & IMenuHeaderParams): void {
    this.params = params;
    this.selectOptions = params.selectOptions;
  }

  onSelectionChange(event: MatSelectChange): void {
    if (this.params && this.params.onSelect) {
      this.checked = this.params.onSelect(event.value);
    }
    // reset selection state so we get selectionChange event every time
    event.source.writeValue(null);
  }

  refresh(params: IHeaderParams): boolean {
    return false;
  }
}
